import { Button, Divider, Flex, Link, Spacer, Text } from "@chakra-ui/react";
import { LuRefreshCw } from "react-icons/lu";

declare const __BUILD_VERSION__: string;

import { useActiveAccount } from "applesauce-react/hooks";
import {
  AppearanceIcon,
  GithubIcon,
  LightningIcon,
  MuteIcon,
  RelayIcon,
} from "../../components/icons";
import Image01 from "../../components/icons/image-01";
import Mail02 from "../../components/icons/mail-02";
import User01 from "../../components/icons/user-01";
import SimpleNavItem from "../../components/layout/components/simple-nav-item";
import SimpleParentView from "../../components/layout/presets/simple-parent-view";
import UserAvatar from "../../components/user/user-avatar";
import VersionButton from "../../components/version-button";

function DividerHeader({ title }: { title: string }) {
  return (
    <Flex alignItems="center" gap="2">
      <Divider />
      <Text fontWeight="bold" fontSize="md">
        {title}
      </Text>
      <Divider />
    </Flex>
  );
}

export default function SettingsView() {
  const account = useActiveAccount();

  return (
    <SimpleParentView title="Settings" path="/settings">
      {account && (
        <>
          <SimpleNavItem to="/settings/accounts" leftIcon={<UserAvatar size="xs" pubkey={account.pubkey} />}>
            Accounts
          </SimpleNavItem>
          <DividerHeader title="Account" />
          <SimpleNavItem to="/settings/profile" leftIcon={<User01 boxSize={5} />}>
            Profile
          </SimpleNavItem>
          <SimpleNavItem to="/settings/mailboxes" leftIcon={<Mail02 boxSize={5} />}>
            Mailboxes
          </SimpleNavItem>
          <SimpleNavItem to="/settings/media-servers" leftIcon={<Image01 boxSize={5} />}>
            Media Servers
          </SimpleNavItem>
          <SimpleNavItem to="/settings/messages" leftIcon={<Mail02 boxSize={5} />}>
            Messages
          </SimpleNavItem>
          <SimpleNavItem to="/settings/mutes" leftIcon={<MuteIcon boxSize={5} />}>
            Mutes
          </SimpleNavItem>
        </>
      )}

      <DividerHeader title="Client" />
      <SimpleNavItem to="/settings/relays" leftIcon={<RelayIcon boxSize={5} />}>
        Relays
      </SimpleNavItem>
      <SimpleNavItem to="/settings/display" leftIcon={<AppearanceIcon boxSize={5} />}>
        Display
      </SimpleNavItem>
      <SimpleNavItem to="/settings/lightning" leftIcon={<LightningIcon boxSize={5} />}>
        Lightning
      </SimpleNavItem>

      <Flex alignItems="center">
        <Link isExternal href="https://github.com/NO7r34L/LitStrudel">
          <GithubIcon /> Github
        </Link>
        <Spacer />
        <VersionButton />
      </Flex>

      <Flex alignItems="center" gap="2" pt="2">
        <Text fontSize="xs" color="gray.500">Build: {typeof __BUILD_VERSION__ !== "undefined" ? __BUILD_VERSION__ : "dev"}</Text>
        <Spacer />
        <Button
          size="xs"
          variant="outline"
          colorScheme="red"
          leftIcon={<LuRefreshCw size={12} />}
          onClick={async () => {
            if ("serviceWorker" in navigator) {
              const regs = await navigator.serviceWorker.getRegistrations();
              await Promise.all(regs.map((r) => r.unregister()));
            }
            const keys = await caches.keys();
            await Promise.all(keys.map((k) => caches.delete(k)));
            window.location.reload();
          }}
        >
          Force Update
        </Button>
      </Flex>
    </SimpleParentView>
  );
}
